import { FunctionComponent, SVGProps } from "react";
import { Container, RightArrowIcon } from "./_selectWithdrawOption"

interface ISelectWithdrawOptionProps {
  options: {
    icon: FunctionComponent<SVGProps<SVGSVGElement>>;
    title: string;
    subtitle: string;
  }[];
  onOptionClick: (value: string) => void;
}

export const SelectWithdrawOption = ({ options, onOptionClick }: ISelectWithdrawOptionProps) => {

  return (
    <Container>
      {
        options.map(({
          icon: Icon,
          title,
          subtitle
        }) => (
          <button key={title} type="button" className="select-withdraw-option__withdraw-option" onClick={() => onOptionClick(title)}>
            <Icon className="select-withdraw-option__option__icon" />
            <div className="select-withdraw-option__withdraw-option__info-wrapper">
              <p className="select-withdraw-option__withdraw-option__title">
                {title}
              </p>
              <p className="select-withdraw-option__withdraw-option__subtitle">
                {subtitle}
              </p>
            </div>
            <RightArrowIcon className="select-withdraw-option__withdraw-option__arrow" />
          </button>
        ))
      }
    </Container>

  )
}
